// This is a simple check to see if the current window is in an iframe.
export function isInIframe(): boolean {
    try {
        return window.self !== window.top
    } catch (_) {
        return true
    }
}
